import React from 'react';
import PropTypes from 'prop-types';
import 'flexboxgrid';
import classnames from 'classnames';

import './grid.scss';

export const Row = ({children, className}) => <div className={classnames('row', className)}>{children}</div>;

Row.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

Row.defaultProps = {
  className: '',
};

export const Col = ({children, size, className}) => (
  <div className={classnames(`col-xs-${size}`, className)}>{children}</div>
);

Col.defaultProps = {
  size: 6,
  className: '',
  children: null,
};

Col.propTypes = {
  size: PropTypes.number,
  children: PropTypes.node,
  className: PropTypes.string,
};
